<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-pencil"></i> Premade Sentences</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
                <router-link v-bind:to="{name: 'add-premade-sentence' }" class="button is-info is-pulled-right">Add new</router-link>
            </div>
            <div class="column">
                <premade-sentences-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged" :total="total" v-bind:items="premadeSentences" v-bind:actions="true"></premade-sentences-table>
            </div>
        </div>          
    </div>  
</template>

<script>
import lodash from 'lodash'
import PremadeSentencesTable from "./Table";

export default {
  name: 'premade-sentences-view',
  components: {PremadeSentencesTable},
  data() {
        return {
            premadeSentences: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
        }
  },
  created(){
    this.getPremadeSentences();
  },
  methods: {
    onSearch(q){
        this.page = 1;
        this.q = q;
        this.getPremadeSentences();
    },
    onOrderBy(orderBy){
        this.page = 1;
        this.orderBy = orderBy;
        this.getPremadeSentences();
    },
    onPageChanged(page){
        this.page = page;        
        this.getPremadeSentences();
    },
      getPremadeSentences(){
          let  data = {
              page: this.page,
              q: this.q,
              orderBy:this.orderBy
          };
        this.premadeSentenceRepo.paginate(data).then(response => {
            this.premadeSentences = response.data.data;
            this.total = response.data.meta.pagination.total_pages            
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/premade-sentences/View.vue